import { differenceInDays } from 'date-fns';

// Expected minimum wet nappies per 24 hours by age
const thresholds = [
  { maxDays: 1, expected: 1 },
  { maxDays: 2, expected: 2 },
  { maxDays: 3, expected: 3 },
  { maxDays: 4, expected: 4 },
  { maxDays: Infinity, expected: 6 },
];

export function getExpectedWetNappies(dateOfBirth) {
  if (!dateOfBirth) return 6;
  const ageDays = differenceInDays(new Date(), new Date(dateOfBirth));
  const threshold = thresholds.find((t) => ageDays <= t.maxDays);
  return threshold ? threshold.expected : 6;
}

export function getHydrationStatus(wetCount, expected) {
  if (wetCount >= expected) return 'good';
  if (wetCount >= expected * 0.5) return 'monitor';
  return 'concern';
}
